import { Resource } from './resource';
import { Filter } from './filters';
import { Space, MultiPointInstallation } from './api';

export type SpacesState = {
  resource: Resource<{
    space: Space;
  }>;
  counts: {
    date: string;
    resource: Resource<Array<{ timestamp: string; bucketCount: number }>>;
  };
  mpis: {
    resource: Resource<Array<MultiPointInstallation>>;
  };
};

export enum SpacesActionTypes {
  SPACES_CHANGE_PAGE_DETAIL = 'SPACES_CHANGE_PAGE_DETAIL',

  SPACES_LOAD_DETAIL_COMPLETE = 'SPACES_LOAD_DETAIL_COMPLETE',

  SPACES_LOAD_START = 'SPACES_LOAD_START',
  SPACES_LOAD_ERROR = 'SPACES_LOAD_ERROR',
  SPACES_LOAD_COMPLETE = 'SPACES_LOAD_COMPLETE',

  SPACES_DETAIL_COUNTS_CHANGE_DATE = 'SPACES_DETAIL_COUNTS_CHANGE_DATE',
  SPACES_DETAIL_COUNTS_LOAD_START = 'SPACES_DETAIL_COUNTS_LOAD_START',
  SPACES_DETAIL_COUNTS_LOAD_ERROR = 'SPACES_DETAIL_COUNTS_LOAD_ERROR',
  SPACES_DETAIL_COUNTS_LOAD_COMPLETE = 'SPACES_DETAIL_COUNTS_LOAD_COMPLETE',

  SPACE_DETAIL_MPIS_LOAD_START = 'SPACE_DETAIL_MPIS_LOAD_START',
  SPACE_DETAIL_MPIS_LOAD_COMPLETE = 'SPACE_DETAIL_MPIS_LOAD_COMPLETE',
  SPACE_DETAIL_MPIS_LOAD_ERROR = 'SPACE_DETAIL_MPIS_LOAD_ERROR',
}

export type SpacesAction =
  | {
      type: SpacesActionTypes.SPACES_CHANGE_PAGE_DETAIL;
      id: Space['external_id'];
    }
  | { type: SpacesActionTypes.SPACES_LOAD_START }
  | {
      type: SpacesActionTypes.SPACES_LOAD_ERROR;
      error: any;
    }
  | {
      type: SpacesActionTypes.SPACES_LOAD_DETAIL_COMPLETE;
      space: Space;
    }
  | { type: SpacesActionTypes.SPACES_DETAIL_COUNTS_CHANGE_DATE; date: string }
  | { type: SpacesActionTypes.SPACES_DETAIL_COUNTS_LOAD_START }
  | { type: SpacesActionTypes.SPACES_DETAIL_COUNTS_LOAD_ERROR; error: any }
  | {
      type: SpacesActionTypes.SPACES_DETAIL_COUNTS_LOAD_COMPLETE;
      counts: Array<{
        timestamp: string;
        bucketCount: number;
      }>;
    }
  | { type: SpacesActionTypes.SPACE_DETAIL_MPIS_LOAD_START }
  | { type: SpacesActionTypes.SPACE_DETAIL_MPIS_LOAD_ERROR; error: any }
  | {
      type: SpacesActionTypes.SPACE_DETAIL_MPIS_LOAD_COMPLETE;
      mpis: Array<MultiPointInstallation>;
    };
